import React from 'react';
import cx from 'classnames';

export type GuidesToggleCardProps = {
    children?: React.ReactNode | React.ReactNode[];
    isActive?: boolean;
    backgroundColor?: string;
};

const GuidesToggleCard: React.FC<GuidesToggleCardProps> = (props) => {
    const componentRef = React.useRef<HTMLDivElement>(null);
    const { isActive, children, backgroundColor } = props;
    const classname = cx({
        'guides-toggle-card': true,
        'is-active': isActive,
    });

    React.useEffect(() => {
        if (isActive) {
            // trick for mobile devices
            setTimeout(() => {
                componentRef?.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }, 0);
        }
    }, [isActive]);

    return (
        <div className={classname} ref={componentRef} style={{ backgroundColor }}>
            {children}
        </div>
    );
};

export default GuidesToggleCard;
